/**
 * @generated SignedSource<<378abfeff41bd6385ac97c24480677d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ImportSalesforceClientsInput = {
  clientIds?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ImportSalesforceClientsMutation$variables = {
  input: ImportSalesforceClientsInput;
};
export type ImportSalesforceClientsMutation$data = {
  readonly importSalesforceClients: {
    readonly clients: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly street: string | null;
        readonly zip: string | null;
        readonly city: string | null;
        readonly vat: string | null;
        readonly country: string | null;
        readonly notes: string | null;
        readonly logoId: string | null;
        readonly logoDefaultId: number | null;
      } | null;
    } | null> | null;
  } | null;
};
export type ImportSalesforceClientsMutation = {
  variables: ImportSalesforceClientsMutation$variables;
  response: ImportSalesforceClientsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImportSalesforceClientsPayload",
    "kind": "LinkedField",
    "name": "importSalesforceClients",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientTypeEdge",
        "kind": "LinkedField",
        "name": "clients",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Client",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zip",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoDefaultId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportSalesforceClientsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportSalesforceClientsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "44fefa3bdfc9e13d705ac664eb4b5fb6",
    "id": null,
    "metadata": {},
    "name": "ImportSalesforceClientsMutation",
    "operationKind": "mutation",
    "text": "mutation ImportSalesforceClientsMutation(\n  $input: ImportSalesforceClientsInput!\n) {\n  importSalesforceClients(input: $input) {\n    clients {\n      cursor\n      node {\n        id\n        name\n        street\n        zip\n        city\n        vat\n        country\n        notes\n        logoId\n        logoDefaultId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e558eb108c7a265b0fbdb50ee1b5a00f";

export default node;
